// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ynYB","search":"Settings_search__2RwtU","filter":"Settings_filter__2-aCz"};